// extracted by mini-css-extract-plugin
module.exports = {"resourceThumbnailContainer":"slider_clickview_item-module__resourceThumbnailContainer___1VUOw","ratingBadge":"slider_clickview_item-module__ratingBadge___kB6xI"};